import React from "react"
import AlertService from "../../../Services/AlertService";
import ApiService from "../../../Services/ApiService";


class Publish extends React.Component {
    state = {
        data: {
            campaign_id: "",
            date_published: ""
        }
    };

    publishCampaign() {
        if (window.confirm("Are you sure you want to publish this campaign?")) {
            ApiService.post('/api/linkedin/publish-campaign', {campaign_id: this.state.data.campaign_id})
                .then ( response => {
                    let successCount = 0;
                    let failureCount = 0;
                    let failedCampaigns = '';
                    let message = '';

                    if ('Successes' in response.data) {
                        successCount = response.data.Successes.length;
                    }

                    if (!response.data.success) {
                        if ('Failures' in response.data) {
                            failureCount = response.data.Failures.length;
                            failedCampaigns = response.data.Failures.join(', ');
                        }

                        message = successCount + " campaign(s) successfully published to LinkedIn.";

                        if (failureCount > 0) {
                            message += "\n" + failureCount + " failed to publish campaign or ad to LinkedIn:  " + failedCampaigns + ".";
                        }

                        if ('error' in response.data) {
                            message += "\n Error Message: " + response.data.error;
                        }

                    } else {
                        message = successCount + " campaign(s) successfully published to LinkedIn. 0 failures.";
                    }

                    let publishInfoEl = document.getElementById('publish-info');
                    publishInfoEl.innerText = message;
                    publishInfoEl.style.display = 'block';
                })
                .catch( error => {
                    AlertService.error('Oops! Something went wrong with publishing the campaign to LinkedIn')
                })
        }
    }

    republishCampaign() {
        if (window.confirm("Are you sure you want to update campaigns that have already been published?")) {
            ApiService.post('/api/linkedin/update-campaign', {campaign_id: this.state.data.campaign_id})
                .then( response => {
                    if (!response.data.success) {
                        AlertService.error('Oops! Something went wrong with updating the campaign bid amounts on LinkedIn');
                    } else {
                        AlertService.success('Campaign successfully updated on LinkedIn');

                    }
                })
                .catch( error => {
                    AlertService.error('Oops! Something went wrong with publishing the campaign to LinkedIn')
                })
        }
    }

    componentDidMount() {
        if (this.props.data) {
            const url = "/api/campaigns/fetch?campaign_id=" + this.props.data.campaignId;
            ApiService.get(url)
                .then(response => {
                    let campaign = response.data.Campaign;
                    if (campaign) {
                        if (campaign.date_published) {
                            document.getElementById("datePublished").style.display = 'block';
                        } else {
                            document.getElementById("datePublished").style.display = 'none';
                        }

                        this.setState ({
                            ...this.state.data,
                             data: campaign,
                        })
                    }
                })
        }
    }

    render() {
        return(
            <div className="account-container">
            <div id="publish-info" className="alert alert-primary">

            </div>
                <div >
                    <h4 id="datePublished"> Date Last Published: {this.state.data.date_published} </h4>

                    <h3>Publish campaign to LinkedIn </h3>
                </div>

                <div>
                    Publishing a campaign will create a Campaign Group (if a LinkedIn Campaign Group ID was not provided) and create
                    a campaign for each account. 2 Ads will be created for every account (if applicable).

                     <p> Campaigns that have already been published will be skipped. </p>
                </div>


                <div>
                    <div className="space-between"></div>
                    <button onClick = {this.publishCampaign.bind(this)}> Publish to LinkedIn</button>
                </div>

            <div>
                <h3>Update published campaigns </h3>
            </div>

                <div>
                    Update the bid amount and/or excluded categories for already published campaigns.
                </div>

                <div>
                    <div className="space-between"></div>
                    <button id="update-campaign-btn" onClick = {this.republishCampaign.bind(this)}> Update published campaigns </button>
                </div>

            </div>
        )
    }
}

export default Publish